import { useMemo } from 'react';
import { useDeclarationsOverview } from '../hooks/useDeclarationsOverview';
import { summaryFromNew } from './fromNew';
import type { DeclarationsSummary } from './types';

export const useDeclarationsSummary = (enabled = true): DeclarationsSummary => {
	const overview = useDeclarationsOverview(enabled);
	return useMemo(
		() => summaryFromNew({ overview: overview.overview, failed: overview.isError }),
		[overview.overview, overview.isError],
	);
};
